<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">总—子账号设置</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1">
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="add"
                >子账号新增+</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table
      :data="list"
      height="500px"
      border
      style="width: 100%"
      class="custom-table"
    >
      <el-table-column align="center" prop="username" label="子账号" />
      <el-table-column align="center" prop="password" label="密码" />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="修改" center width="366px" v-model="dialogTableVisible">
      <div class="update-view">
        <div class="item">
          <span class="label">子账号：</span>
          <label
            ><input
              disabled
              style="margin-left: 15px"
              type="text"
              class="cg-input"
              v-model="upusername"
          /></label>
        </div>
        <div class="item">
          <span class="label">密码：</span>
          <label
            ><input
              style="margin-left: 15px"
              type="text"
              class="cg-input"
              v-model="uppass"
          /></label>
        </div>
        <div class="footer">
          <el-button class="custom-btn" size="small" @click="save"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { ElMessage } from "element-plus";

const { proxy } = getCurrentInstance();
const $api = proxy.$api;

const list = ref([]);
const userid = ref("");
const dialogTableVisible = ref(false);
const upusername = ref("");
const uppass = ref("");

// 获取子账号列表
const getlist = async () => {
  const res = await $api.BasicData.getSubMemberList({});
  console.log(res.data.code);
  if (res.data.code == 200) {
    list.value = res.data.data.list;
    console.log(list.value, "返回的列表是什么格式");
  } else {
    ElMessage.error("网络错误");
    list.value = [];
  }
};

// 删除子账号
const delUser = async (id) => {
  const sendata = { id: id };
  const res = await $api.BasicData.deleteSubMember(sendata);
  if (res.data.code == 200) {
    ElMessage.success("删除成功");
    getlist();
  } else {
    ElMessage.error("网络错误");
  }
};

// 新增子账号
const add = async () => {
  const res = await $api.BasicData.addSubMember({});
  if (res.data.code == 200) {
    ElMessage.success("新增成功");
    getlist();
  } else {
    ElMessage.error("网络错误");
  }
};

// 打开修改弹窗
const up = async (row) => {
  userid.value = "";
  upusername.value = "";
  uppass.value = "";
  upusername.value = row.username;
  uppass.value = row.password;
  userid.value = row.id;
  dialogTableVisible.value = true;
};

// 保存修改
const save = async () => {
  const sendata = {
    id: userid.value,
    password: uppass.value,
  };
  console.log("参数是否正确", sendata);
  try {
    const res = await $api.BasicData.updateSubMember(sendata);
    if (res.data.code == 200) {
      dialogTableVisible.value = false;
      ElMessage.success("修改成功");
      getlist();
    } else {
      ElMessage.error("修改失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    ElMessage.error("网络错误，修改失败");
  }
};

onMounted(() => {
  getlist();
});
</script>

<style lang="scss" scoped>
@import "./subAccount.scss";
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
:deep(.el-dialog) {
  margin-top: 25vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 120px !important;
}
.main-panel.large {
  background-color: #fff;
}
.panel-title {
  color: #666;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper {
    background-color: #fff !important;
    .el-table__header {
      background-color: #fff !important;
      th {
        background-color: #fff !important;
      }
    }
  }
  .el-table__body-wrapper {
    background-color: #fff !important;
    .el-table__body {
      background-color: #fff !important;
      td {
        background-color: #fff !important;
      }
    }
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
</style>
